module.exports = __webpack_public_path__ + "img/money1.c6724cc2.png";